





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from './Modal.vue';

export interface FooterObject {
  label: string;
  icon?: string;
  img?: string;
}

export interface PageObject {
  title: string;
  content: string | string[];
}

@Component({
  components: {
    Modal,
  },
})
export default class Footer extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  public items!: FooterObject[];
  public v!: Modal;

  @Prop({
    type: Object,
    required: true,
  })
  private pages!: { [p in string]: PageObject };

  public openModal(type: string) {
    const v = this.$refs.modal as Modal;
    v.show(this.pages[type]);
  }
}
